import { render } from "./TVPHighVariance.vue?vue&type=template&id=7df9ebd0"
import script from "./TVPHighVariance.vue?vue&type=script&lang=js"
export * from "./TVPHighVariance.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__